import { render, staticRenderFns } from "./InsurerView.vue?vue&type=template&id=fab730a8"
import script from "./InsurerView.vue?vue&type=script&lang=js"
export * from "./InsurerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports